import styled from 'styled-components'
import { colors, fontWeights } from '@/styles'
import Skeleton from '@/components/skeleton'

const Wrapper = styled.div`
  width: 100%;
  background: ${colors.grey96};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-width: 1px 0px;
  border-style: solid;
  border-color: ${colors.grey88};
  padding: 8px 10px;
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 20px;
  color: ${colors.grey16};
`

const EmptyComponent = ({ children, isLoading }) => {
  return <Wrapper>{isLoading ? <Skeleton width="100%" height={20} /> : children}</Wrapper>
}

export default EmptyComponent
